export default __webpack_public_path__ + "static/media/old_xylem_pump.1d9dfae8.png";